// extracted by mini-css-extract-plugin
export default {"link":"P4n8lRW0JIN2FNlesZ1A"};